/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  belongsTo,
  attr,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from 'linced-app/models/school';

// Proto: finance.Till.
export default class Till extends Model {
  declare [Type]: 'finance/till';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare code: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('boolean', { defaultValue: false })
  declare isActive: boolean;
}
